import { Deploy } from 'cordova-plugin-ionic';

export const setup = async () => {
  const channel = process.env.REACT_APP_CHANNEL_NAME;

  if (channel) {
    await Deploy.configure({ channel });
  }
};
